<template>
  <div class="comStatusBarCard_container">
    <div
      class="comStatusBarCard_container_title mb-1"
      v-if="title || rightLabel"
    >
      <div
        :class="[
          'title_left',
          !rightLabel ? type : '',
          show ? 'comStatusBarCard_color' : '',
        ]"
      >
        {{ title }}
      </div>
      <div v-if="rightLabel" :class="['title_right', type]">
        {{ rightLabel }}
      </div>
      <div
        class="comStatusBarCard_right comStatusBarCard_center"
        v-if="righttext"
        @click="getpath"
      >
        {{ righttext }}
        <div>
          <img
            :src="Right_img"
            alt=""
            style="width: 20px; height: 20px; padding-left: 5px"
          />
        </div>
      </div>
    </div>
    <div class="comStatusBarCard_container_list" v-if="showList">
      <div
        :class="[
          'list_item',
          'mb-0',
          index == showList.length - 1 && index % 2 == 0 ? 'last_item' : '',
        ]"
        v-for="(item, index) in showList"
        :key="index"
      >
        <div class="list_item_title mb-0">{{ item.title }}</div>
        <div class="list_item_label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComStatusBarCard",
  props: {
    title: {
      type: String,
      default: "状态栏",
    },
    rightLabel: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "success", // 状态类型，success、warning、error、cancel
    },
    showList: {
      // 数组长度为单数的时候最后一个通栏展示
      type: Array,
      default: () => [
        {
          title: 200.02,
          label: "当前收益(USDT)",
        },
        {
          title: 200.02,
          label: "当前收益(USDT)",
        },
      ],
    },
    Right_img: {
      // 数组长度为单数的时候最后一个通栏展示
      type: String,
      default: require("@/assets/image/Miracle/homePage/index_right.png"),
    },
    righttext: {
      type: String,
      default: "",
    },
    // 样式显示
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getpath() {
      this.$emit("Path");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>